import React from 'react'
import { SocialIcon } from '../../components/common/SocialIcon'
import Particles from '../../components/particles'
import Typical from 'react-typical'
import { faFacebookF, faTwitter, faLinkedinIn, faSkype, faInstagram } from '@fortawesome/free-brands-svg-icons'

export default function Slider() {
    return (
        <section className="slider-wrapper site-margin" id="Home">
            <div className="container">
               <div className="slider-double-items">
                  <div className="content">
                     <div className="slider-content text-center">
                        <div className="slider-img">
                           <img src={require('../../assets/images/slider-img.png')} alt="" title="" />
                        </div>
                        <h2>
                           <Typical
                           steps={['I’m Web', 1000, 'I’m Web Developer.', 1000, 'I’m Web Designer.', 1000]}
                           loop={Infinity}
                           wrapper="span"
                           /> 
                        </h2>
                        <h5>Ryland Doe</h5>
                        <p>A full stack all around web designer and developer that may or 
                           may not include a guide for specific creative potential methods who framing and evaluating moves.
                        </p>
                        <ul className="social-links-wrapper">
                           <SocialIcon sociallink="#" socialIcon={faFacebookF} />
                           <SocialIcon sociallink="#" socialIcon={faTwitter} />
                           <SocialIcon sociallink="#" socialIcon={faLinkedinIn} />
                           <SocialIcon sociallink="#" socialIcon={faInstagram} />
                           <SocialIcon sociallink="#" socialIcon={faSkype} />
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
            <Particles />
        </section>
    )
}